/**
 * @description 全局Model releaseModel 挂载到 redux 上
 */
import createModel, { Tction } from '@tkit/model';
import { APIS } from '@src/services';
import * as models from '@services/model/models';
import { ParamssearchPageTabUsingGet } from '@src/services/api/SearchApi';
import { ParamsBodyarticlePublishUsingPut } from '@src/services/api/ArticleApi';
import { ParamsgroupsJoinsUsingGet } from '@src/services/api/GroupApi';
import { ParamsteamsJoinsUsingGet } from '@src/services/api/TeamApi';

export interface State {
  tagListModel: models.SearchItemCondition[];
  groupListModel: models.SearchItemCondition[];
  teamListModel: models.SearchItemCondition[];
}

export const releaseModelState: State = {
  tagListModel: [],
  groupListModel: [],
  teamListModel: []
};

const model = createModel({
  state: releaseModelState,
  namespace: 'releaseModel',
  reducers: {
    // 搜索圈子
    setGroupList: (state, action: Tction<{ groupListModel: models.SearchItemCondition[] }>) => {
      return {
        ...state,
        groupListModel: action.payload.groupListModel
      };
    },
    // 搜索团队
    setTeamList: (state, action: Tction<{ teamListModel: models.SearchItemCondition[] }>) => {
      return {
        ...state,
        teamListModel: action.payload.teamListModel
      };
    },
    // 搜索标签
    setTagList: (state, action: Tction<{ tagListModel: models.SearchItemCondition[] }>) => {
      return {
        ...state,
        tagListModel: action.payload.tagListModel
      };
    }
  },
  effects: {
    // 搜索用户/圈子/团队/标签
    *getList(
      { namespace, put, tPut, tCall },
      action: Tction<{ params: ParamssearchPageTabUsingGet }>
    ): Iterator<{}, any, any> {
      const {
        params,
        params: { type, keyWord }
      } = action.payload;
      const typeStr = type.charAt(0) + type.slice(1).toLowerCase();
      let data = [];
      if (keyWord !== '') {
        const res = yield tCall(APIS.SearchApi.searchPageTabUsingGet, params);
        const { code, result } = res;
        if (code === 0) {
          data = result;
        }
      }
      yield tPut(model.actions[`set${typeStr}List`], {
        [`${type.toLowerCase()}ListModel`]: data
      });
    },
    // 发布
    *publish(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsBodyarticlePublishUsingPut;
        callBack: (res: models.CommonResult) => void;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.ArticleApi.articlePublishUsingPut, action.payload.params);
      action.payload.callBack(res);
    },
    // 获取加入的圈子
    *getGroupsJoins(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsgroupsJoinsUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.GroupApi.groupsJoinsUsingGet, action.payload.params);
      const { result, code } = res;
      if (code === 0) {
        yield tPut(model.actions.setGroupList, {
          groupListModel: result
        });
      }
    },
    // 获取加入的团队
    *getTeamJoins(
      { namespace, put, tPut, tCall },
      action: Tction<{
        params: ParamsteamsJoinsUsingGet;
      }>
    ): Iterator<{}, any, any> {
      const res = yield tCall(APIS.TeamApi.teamsJoinsUsingGet, action.payload.params);
      const { result, code } = res;
      if (code === 0) {
        yield tPut(model.actions.setTeamList, {
          teamListModel: result
        });
      }
    }
  }
});

export default model;
